import SampleDocument from '@/assets/sampleDocuments/Insurance claim form.pdf';
import { TemplateModel } from '@/components/ui';
import { FORMATTER_CLASSIFICATION_FUNCTION_ID } from '@/constants';

import { dateFormatter, highConfidenceValidator, numericFormatter } from './common.ts';

export const HEALTH_INSURANCE_CLAIM_FORM: TemplateModel = {
  fields: [
    {
      id: 'name',
      type: 'single-value',
      name: 'Name',
      promptHint: "The patient's name. First and last name.",
      validators: [highConfidenceValidator],
    },
    {
      id: 'address',
      type: 'single-value',
      name: 'Address',
      promptHint: "The patient's address. No, street.",
      validators: [highConfidenceValidator],
    },
    {
      id: 'city',
      type: 'single-value',
      name: 'City',
      promptHint: "The patient's city of residence.",
      validators: [highConfidenceValidator],
    },
    {
      id: 'zip',
      type: 'single-value',
      name: 'Zip Code',
      promptHint: "The patient's zip code",
      formatters: [numericFormatter],
      validators: [highConfidenceValidator],
    },
    {
      id: 'telephone',
      type: 'single-value',
      name: 'Telephone',
      promptHint: "The patient's telephone number",
      validators: [highConfidenceValidator],
    },
    {
      id: 'date_of_birth',
      type: 'single-value',
      name: 'Date of birth',
      promptHint: "The patient's date of birth",
      formatters: [dateFormatter],
      validators: [highConfidenceValidator],
    },
    {
      id: 'relationship_to_insured',
      type: 'single-value',
      name: 'Relationship to insured.',
      promptHint: "The patient's relationship to the ensured person",
      validators: [highConfidenceValidator],
      formatters: [
        {
          functionId: FORMATTER_CLASSIFICATION_FUNCTION_ID,
          name: 'Relationship',
          description: 'Relationship to the ensured person',
          config: {
            labels: [
              { value: 'self', description: 'Self' },
              { value: 'spouse', description: 'Spouse' },
              { value: 'child', description: 'Child' },
              { value: 'other', description: 'Other' },
            ],
            catchAll: 'other',
          },
        },
      ],
    },
    {
      id: 'marital_status',
      type: 'single-value',
      name: 'Marital status.',
      promptHint: "The patient's marital status",
      validators: [highConfidenceValidator],
      formatters: [
        {
          functionId: FORMATTER_CLASSIFICATION_FUNCTION_ID,
          name: 'Status',
          description: 'Marital status',
          config: {
            labels: [
              { value: 'single', description: 'Single' },
              { value: 'married', description: 'Married' },
              { value: 'other', description: 'Other' },
            ],
            catchAll: 'other',
          },
        },
      ],
    },
  ],
  sampleDocuments: [SampleDocument],
};
